module.exports = __webpack_public_path__ + "static/media/notificationPractice1.9948613e.mp3";